/* GTF 2026 — solo quello che serve. Nessuna libreria. */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');

  /* menu a schermo intero */
  var menu = document.getElementById('gtf-menu');
  var body = document.body;
  function setMenu(open) {
    if (!menu) return;
    menu.setAttribute('data-open', open ? 'true' : 'false');
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    body.classList.toggle('is-locked', open);
    document.querySelectorAll('[data-menu-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (open) { var f = menu.querySelector('a,button'); if (f) f.focus(); }
  }
  document.querySelectorAll('[data-menu-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      setMenu(menu.getAttribute('data-open') !== 'true');
    });
  });
  document.querySelectorAll('[data-menu-close]').forEach(function (b) {
    b.addEventListener('click', function () { setMenu(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu && menu.getAttribute('data-open') === 'true') {
      setMenu(false);
      var t = document.querySelector('[data-menu-open]'); if (t) t.focus();
    }
  });

  /* reveal allo scroll */
  var els = document.querySelectorAll('[data-rv]');
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('rv-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('rv-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* filtri archivio tappe, lato client, senza ricaricare */
  document.querySelectorAll('[data-filter-group]').forEach(function (group) {
    var target = document.querySelector(group.getAttribute('data-filter-target'));
    if (!target) return;
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-filter]');
      if (!btn) return;
      var val = btn.getAttribute('data-filter');
      group.querySelectorAll('[data-filter]').forEach(function (b) {
        b.classList.toggle('is-on', b === btn);
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      var shown = 0;
      target.querySelectorAll('[data-ev]').forEach(function (row) {
        var ok = val === 'all' || row.getAttribute('data-ev').indexOf(val) > -1;
        row.hidden = !ok;
        if (ok) shown++;
      });
      var empty = document.querySelector(group.getAttribute('data-filter-empty') || '#gtf-empty');
      if (empty) empty.hidden = shown > 0;
    });
  });

  /* video hero: parte solo se ha senso */
  var v = document.querySelector('[data-hero-video]');
  if (v) {
    var slow = navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (slow || reduce) { v.removeAttribute('autoplay'); v.pause && v.pause(); }
    else { var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); }
  }
})();
